import { AuthService } from '@appService/auth.service'
import { Component, EventEmitter, Input, NgZone, Output, SimpleChanges, TemplateRef } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzMessageService } from 'ng-zorro-antd/message'
import { NzModalService } from 'ng-zorro-antd/modal'
import { TranslateService } from '@ngx-translate/core'
import { MenuComponent, VirtualDataSource, VssAuthService, VssTabDynamicService } from 'projects/vss-ui/src/public-api'
import { ApplicationsSelectedService } from '@app/service/stores/applications-selected.service'
import { environment } from '@appEnv/environment'
import { NotifyService } from '@app/service/notify/notify.service'
import { catchError, filter, map } from 'rxjs/operators'
import { ResponseCode } from '@app/modules/shares/enum/common.enum'
import * as moment from 'moment'
import { MenuModel } from '@app/models/menu.model'
import { KeycloakService } from 'keycloak-angular'
import { SidebarService } from "@appService/shares/sidebar-service"

@Component({
  selector: 'menu-nav',
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.scss'],
})
export class MenuNavComponent extends MenuComponent {
  @Input() contentTpl!: TemplateRef<any>
  @Input() extendStartTpl!: TemplateRef<any>
  @Input() extendEndTpl!: TemplateRef<any>
  @Output() onLogout: EventEmitter<any>
  user: any
  totalNewNotify = 0
  sysNotification: any[] = [{ value: 'VNA', label: 'VNA', totalNewNotify: 0, total: 0, read: 0 }]
  indexTabNotifyActive = 0
  // currentLang: string = localStorage.getItem('language') || 'vi'
  labelTranslate: string = ''
  dataNotify!: VirtualDataSource
  sysNotificationActive = environment.applicationCode
  currentUser: any
  lstNotify: any[] = []
  tabs: any = [
    {
      id: 1,
      name: 'Mới',
      icon: 'apple',
      list: [],
      textCount: 'totalNewNotify',
      nameKey: 'NOTIFY.NEW'
    },
    {
      id: 2,
      name: 'Đã đọc',
      icon: 'android',
      list: [],
      textCount: 'read',
      nameKey: 'NOTIFY.READ'
    },
    {
      id: 0,
      name: 'Tất cả',
      icon: 'android',
      list: [],
      textCount: 'total',
      nameKey: 'NOTIFY.ALL'
    }
  ]

  // listLangModel: OptionModel[] = [
  //   {
  //     value: 'vi',
  //     label: 'Tiếng việt',
  //   },
  //   {
  //     value: 'en',
  //     label: 'English',
  //   }
  // ]
  // listLang: any[] = []

  // onSelectLange(lang: string): void {
  //   localStorage.setItem('language', lang)
  //   this.currentLang = lang
  //   this.translate.use(lang).subscribe(() => {
  //     this.setMenu(this.menus)
  //   }
  //   )

  // }

  public setMenu(menus: MenuModel[]): void {
    menus.forEach((item, index) => {
      item.id = `${index}`
      // this.translate.get(item.titleKey).subscribe(
      //   r => {
      //     item.title = r
      //   }
      // )
      item.title = item.titleKey
      if (item.children.length > 0) {
        this.setMenu(item.children)
      }
    })
  }

  menus: MenuModel[] = []

  defaultMenus: MenuModel[] = [
    // {
    //   'icon': '/assets/icons/menu-dashboard.svg',
    //   'iconActive': 'assets/icons/menu-dashboard-active.svg',
    //   'id': '1',
    //   'level': 0,
    //   'title': 'MENU.DASHBOARD',
    //   'titleKey': 'MENU.DASHBOARD',
    //   'url': '/vna/dashboard',
    //   roles: [],
    //   'children': []
    // },
    // {
    //   'icon': '/assets/icons/menu-function.svg',
    //   'iconActive': 'assets/icons/menu-function-active.svg',
    //   'id': '2',
    //   'level': 0,
    //   'title': 'MENU.SAMPLE',
    //   'titleKey': 'MENU.SAMPLE',
    //   'url': '/vna/sample',
    //   roles: [],
    //   'children': []
    // },
    // {
    //   'icon': '/assets/icons/menu-admin.svg',
    //   'iconActive': 'assets/icons/menu-admin-active.svg',
    //   'id': '3',
    //   'level': 0,
    //   'title': 'MENU.ADMIN.ADMIN',
    //   'titleKey': 'MENU.ADMIN.ADMIN',
    //   'url': '/vna/admin',
    //   roles: [],
    //   'children': [
    //     {
    //       'icon': '',
    //       'id': '4',
    //       'level': 1,
    //       'title': 'MENU.ADMIN.PARAM_CONFIG_MANAGEMENT',
    //       'titleKey': 'MENU.ADMIN.PARAM_CONFIG_MANAGEMENT',
    //       'url': '/vna/admin/param-config-management',
    //       roles: [],
    //       'children': []
    //     },
    //     {
    //       'icon': '',
    //       'id': '5',
    //       'level': 1,
    //       'title': 'MENU.ADMIN.FUNCTION_MANAGEMENT',
    //       'titleKey': 'MENU.ADMIN.FUNCTION_MANAGEMENT',
    //       'url': '/vna/admin/function-management',
    //       roles: [],
    //       'children': []
    //     },
    //     {
    //       'icon': '',
    //       'id': '6',
    //       'level': 1,
    //       'title': 'MENU.ADMIN.FUNCTION_LIST',
    //       'titleKey': 'MENU.ADMIN.FUNCTION_LIST',
    //       'url': '/vna/admin/function-list',
    //       roles: [],
    //       'children': []
    //     },
    //     {
    //       'icon': '',
    //       'id': '7',
    //       'level': 1,
    //       'title': 'MENU.ADMIN.USER_MANAGEMENT',
    //       'titleKey': 'MENU.ADMIN.USER_MANAGEMENT',
    //       'url': '/vna/admin/user-management',
    //       roles: [],
    //       'children': []
    //     },
    //     {
    //       'icon': '',
    //       'id': '8',
    //       'level': 1,
    //       'title': 'MENU.ADMIN.PERMISSION_DATA_MANAGEMENT',
    //       'titleKey': 'MENU.ADMIN.PERMISSION_DATA_MANAGEMENT',
    //       'url': '/vna/admin/permission-data-management',
    //       roles: [],
    //       'children': []
    //     },
    //     {
    //       'icon': '',
    //       'id': '9',
    //       'level': 1,
    //       'title': 'MENU.ADMIN.USER_LIST',
    //       'titleKey': 'MENU.ADMIN.USER_LIST',
    //       'url': '/vna/admin/user-management/user-list',
    //       roles: [],
    //       'children': []
    //     },
    //   ]
    // },
  ]

  // logoUrl = '/assets/images/logo/logo-viettel.png'
  // menuForApp = [
  //   {
  //     'icon': 'fa-cogs',
  //     'children': [
  //       {
  //         'icon': '',
  //         'children': [],
  //         'id': '21',
  //         'level': 1,
  //         'title': 'Thiết lập tham số',
  //         'url': '/admin/param-config-management',
  //       },
  //       {
  //         'icon': '',
  //         'children': [],
  //         'id': '22',
  //         'level': 1,
  //         'title': 'Danh sách chức năng',
  //         'url': '/admin/function-management',
  //       },
  //       {
  //         'icon': '',
  //         'children': [],
  //         'id': '23',
  //         'level': 1,
  //         'title': 'Quản lý tính năng',
  //         'url': '/admin/function-list',
  //       },
  //       {
  //         'icon': '',
  //         'children': [],
  //         'id': '24',
  //         'level': 1,
  //         'title': 'Quản lý nhóm quyền',
  //         'url': '/admin/user-management',
  //       },
  //       {
  //         'icon': '',
  //         'children': [],
  //         'id': '25',
  //         'level': 1,
  //         'title': 'Phân quyền dữ liệu',
  //         'url': '/admin/permission-data-management',
  //       },
  //       {
  //         'icon': '',
  //         'children': [],
  //         'id': '26',
  //         'level': 1,
  //         'title': 'Quản lý người dùng',
  //         'url': '/admin/user-management/user-list',
  //       }
  //     ],
  //     roles: ['ROLE_OPERATION'],
  //     'id': '2',
  //     'level': 0,
  //     'title': 'Thiết lập chung',
  //     'url': '',
  //   }
  // ]

  // appSelected$ = this.appSelectedService?.applicationCurrent$



  constructor(
    private _router: Router,
    private ngZone: NgZone,
    private _tabDynamicService: VssTabDynamicService,
    private _notification: NzNotificationService,
    private _message: NzMessageService,
    private modalService: NzModalService,
    private notifyService: NotifyService,
    private appSelectedService: ApplicationsSelectedService,
    public translate: TranslateService,
    private vssAuthService: VssAuthService,
    private _authService: AuthService,
    protected readonly keycloakService: KeycloakService,
    private sidebarService: SidebarService,
  ) {
    super(_router, _tabDynamicService, _notification, _message, _authService)
  }

  ngOnInit() {
    super.ngOnInit()
    // this.cdr?.detectChanges()
    this.menus = this.defaultMenus
    this.setMenu(this.menus)
    // this.getLang()
    this.sidebarService.isCollapsed$.subscribe(state => {
      this.isCollapsed = state
    })
    // this.flattenMenu(this.menuForApp)

    // this._router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe(event => {
    //   const navEnd = event as NavigationEnd // ép kiểu an toàn
    //   const menu = this._tabDynamicService.getDataRoutes()
    //   const menuItem = menu.find((t: any) =>
    //     t.url === navEnd.urlAfterRedirects ||
    //     t?.url_pattern?.test(navEnd.urlAfterRedirects) ||
    //     t?.urlPattern?.test(navEnd.urlAfterRedirects)
    //   )

    //   this._tabDynamicService.setCurrentPage({
    //     ...menuItem,
    //     state: this._router.getCurrentNavigation()?.extras.state,
    //     url: navEnd.urlAfterRedirects
    //   })
    // })
  }
  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes)
    // if (!changes?.listMenus?.firstChange) {
    //   this.flattenMenu(this.menuForApp)
    // }
  }

  // getMenuIcon(menu: any, currentPage: any) {
  //   if (currentPage?.url.includes('/admin/') && menu?.url.includes('/admin/')) {
  //     return '/assets/icons/menu-setting-color-red.svg'
  //   } else if (currentPage?.url.includes('/target/')) {
  //     return '/assets/icons/menu-target-color-red.svg'
  //   } else if (currentPage?.url.includes('/kpi/')) {
  //     return '/assets/icons/menu-target-color-red.svg'
  //   } else if (currentPage?.url.includes('/category/')) {
  //     return '/assets/icons/menu-category-color-red.svg'
  //   } else if (currentPage?.url.includes('/warning/')) {
  //     return '/assets/icons/menu-warning-color-red.svg'
  //   } else if (currentPage?.url.includes('/report/')) {
  //     return '/assets/icons/menu-report-color-red.svg'
  //   } else {
  //     return menu?.icon
  //   }
  // }

  interval: any
  log(menuId: any) {

  }
  resetInterval() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    this.getAllNotify()
    this.interval = setInterval(() => {
      this.getAllNotify()
    }, 60000)
  }

  getAllNotify() {
    return this.notifyService.filterByStaff(
      { page: 1, size: 10000, staffId: this.user?.userName, app_code: environment.applicationCode }
    ).subscribe((x: any) => {
      if (x.code === ResponseCode.SUCCESS) {
        if (x.data) {
          this.sysNotification.map((a: any) => {
            a.totalNewNotify = x.data?.unread?.totalElements || 0
            a.read = x.data?.read?.totalElements || 0
            a.total = x.data?.all?.totalElements || 0

          })
          this.totalNewNotify = x.data?.unread?.totalElements || 0
        }
      }

    })
  }

  trackByFn(index: number, item: any) {
    return item.id // unique id corresponding to the item
  }

  popoverNotifyOnChangeShow(event: any) {
    if (event) {
      this.changeTabNotify({ index: 0 })
    }
  }

  changeTabNotify(event: any) {
    const tab = this.tabs[event.index]
    if (tab) {
      this.indexTabNotifyActive = event.index
      this.refreshNotify()
    }
  }

  PAGE_SIZE = 10

  refreshNotify() {
    this.dataNotify = new VirtualDataSource(this.apiGetNotify, this.PAGE_SIZE, 1)
  }

  apiGetNotify = (params: any) => {
    return this.notifyService.searchApi
      (
        { usernames: [this.user?.email] },
        {
          read: this.tabs[this.indexTabNotifyActive]?.id || 0, staffId: this.user?.email,
          app_code: environment.applicationCode, ...(params || { page: 1, size: this.PAGE_SIZE })
        }
      )
      .pipe(
        map(x => x),
        catchError((res: any) => {

          return res
        })
      )
  }

  changeTabSys() {

  }

  routerNotify(event: any) {
    event.app_code = environment.applicationCode
    this.notifyService.updateReadNotify(event).subscribe(x => {
      this.resetInterval()
      event.readNotify = moment().format('X')
      if (event?.redirect) {
        this.ngZone.run(() => {
          const ticketUrl = event?.redirect
          this._router.navigateByUrl(ticketUrl)
        })
      }
    })
  }

  updateReadAll() {
    this.notifyService.updatereadall({
      usernames: [this.user?.email],
      app_code: environment.applicationCode
    }).subscribe(() => {
      this.refreshNotify()
      this.resetInterval()
    })
  }

  changeLogo: boolean = true
  onChangeExpand(event: any) {
    this.changeLogo = event
  }

  // async getLang() {
  //   this.listLang = [
  //     {
  //       id: 'vi',
  //       value: 'MENU.LANGUAGE.VIETNAMESE',
  //       icon: './../../../assets/images/language-vietnamese.png'
  //     },
  //     {
  //       id: 'en',
  //       value: 'MENU.LANGUAGE.ENGLISH',
  //       icon: './../../../assets/images/language-english.png'
  //     }
  //   ]
  // }
  logout() {
    this.onLogout.emit()
  }
}
